/**
 * Check buttons list component script
 */
export const ListAddItems = (function () {
    var init = function () {
        $('.list-add-items-action-add').on('click', function () {

            const parentElem = $(this).closest('.list-add-items-container');
            const key = $(parentElem).attr('data-attr-key');
            let value = $(parentElem).find('.list-add-items-value').val();
            if(!value){
                return false;
            }
            $(parentElem).find('.list-add-items-list').append(
                '<li>' + 
                    value + 
                    '' +
                '<input type="hidden" name="inputs['+key+'][]" class="bsave bsave-multi" data-attr-key="'+key+'" value="' + value + '" />' +
                    '<svg class="list-add-items-list-remove-item" class="bi" width="21" height="21" fill="currentColor">'+
                        '<use xlink:href="/static/images/bootstrap-icons.svg#x" />'+
                    '</svg>'+
                '</li>'
            );
            MaMFormHandler.init();
            $(parentElem).find('.bsave-multi[data-attr-key="'+key+'"]').first().trigger('blur');
            $(parentElem).find('.list-add-items-value').val('');
            initRemove();
        });


        $(".list-add-items-value").on('keypress', function (e) {

            e.stopPropagation();

            const parentElem = $(this).closest('.list-add-items-container');
            let value = $(parentElem).find('.list-add-items-value').val();

            if(e.key === 'Enter' && value){
                $('.list-add-items-action-add').trigger('click');
                return false;
            }

            
        });
        initRemove();
    };

    var initRemove = function(){
        $('.list-add-items-list-remove-item').off().on('click', function(){
            var key = $(this).closest('.list-add-items-container').attr('data-attr-key');
            $(this).closest('li').remove();
            $('.bsave-multi[data-attr-key="'+key+'"]').first().trigger('blur');
        });
    };
  
    return {
      init: init,
    };
  })();
  